// src/components/SiteNavJsonLd.jsx
import React from 'react'
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export default function SiteNavJsonLd() {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": "https://onlinegrowthclub.nl/",
          "name": "Online Growth Club",
          "description": "Wij bouwen websites, verzorgen SEO, SEA en social media zodat jij meer klanten krijgt.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://onlinegrowthclub.nl/?s={search_term_string}",
            "query-input": "required name=search_term_string"
          },
          "hasPart": [
            {
              "@type": "SiteNavigationElement",
              "name": "Over Ons",
              "url": "https://onlinegrowthclub.nl/over-ons"
            },
            {
              "@type": "SiteNavigationElement",
              "name": "Diensten",
              "url": "https://onlinegrowthclub.nl/diensten"
            },
            {
              "@type": "SiteNavigationElement",
              "name": "Portfolio",
              "url": "https://onlinegrowthclub.nl/portfolio"
            },
            {
              "@type": "SiteNavigationElement",
              "name": "Blog",
              "url": "https://onlinegrowthclub.nl/blog"
            },
            {
              "@type": "SiteNavigationElement",
              "name": "Contact",
              "url": "https://onlinegrowthclub.nl/contact"
            }
          ]
        })}
      </script>
    </Helmet>
  )
}
